import script from "./Sanctions.vue?vue&type=script&setup=true&lang=js"
export * from "./Sanctions.vue?vue&type=script&setup=true&lang=js"

import "./Sanctions.vue?vue&type=style&index=0&id=546aea70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546aea70"]])

export default __exports__